import * as React from 'react';

import SubscribedTaskSource from '../Source/SubscribedTaskSource/SubscribedTaskSource';
import { Provider } from './SubscribedTasksContext';

class SubscribedTasksProvider extends React.PureComponent<React.PropsWithChildren<unknown>> {
  render() {
    return (
      <SubscribedTaskSource>
        {(subscribedTasks, helpers, queryResult) => (
          <Provider
            value={{
              subscribedTasks,
              subscribedTaskHelpers: helpers,
              queryResult,
            }}
          >
            {this.props.children}
          </Provider>
        )}
      </SubscribedTaskSource>
    );
  }
}

export default SubscribedTasksProvider;
